"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const NavItem = ({ children, disabled, active, slot, className, 'data-test': dataTest }) => {
    const classes = (0, classnames_1.default)({
        'hot-nav__item--disabled': disabled,
        'hot-nav__item--active': active
    }, className);
    return ((0, jsx_runtime_1.jsx)("hot-nav-item", { slot: slot, class: classes, "data-test": dataTest, "data-item-active": active, "data-item-disabled": disabled, children: children }));
};
exports.default = NavItem;
